import { render } from "./ExamProtocolExams.vue?vue&type=template&id=3d32aba8"
import script from "./ExamProtocolExams.vue?vue&type=script&lang=js"
export * from "./ExamProtocolExams.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__